<form #preChatForm id="preChatForm" [formGroup]="form" action="/Home/Chat" method="post" (submit)="onSubmit($event)" [ngClass]="isBrowserSupported ? '' : 'chat-form-browser-unsupported'">
  <ng-container *ngIf="isActiveFormValid()">
    <div *ngFor="let row of activeForm.rows | fieldSort">
      <app-form-field [form]="form" [field]="row" [displaySetting]="settings.displaySetting"></app-form-field>
    </div>
  </ng-container>

  <input type="hidden" name="PreChatFormId" [value]="activeForm.id" />
  <input type="hidden" name="PreChatFormTag" [value]="settings.formTag" />
  <input type="hidden" name="PreChatFormType" [value]="settings.formType" />
  <input type="hidden" name="SourceUrl" [value]="settings.sourceUrl" />
  <input type="hidden" name="DisplaySettingId" [value]="settings.displaySetting.Id" />
  <input type="hidden" name="SessionId" [value]="settings.chatSessionId" />
  <input type="hidden" name="UserLanguage" [value]="language" />
  <input type="hidden" name="OverriddenSkillAddress" [value]="overriddenSkillAddresses" />
  <input type="hidden" name="TargetSkillAddress" [value]="targetSkillAddress" />
  <input type="hidden" id="Parameters_TimeZoneOffset_" name="Parameters[TimeZoneOffset]" [value]="timezone">
  <input type="hidden" id="Parameters_DocumentReferrer_" name="Parameters[DocumentReferrer]" [value]="documentReferrer">
  <input *ngFor="let param of customParams$ | async" type="hidden" name="Parameters[ChatParam_{{param.name}}]" [value]="param.value" />
  <input *ngFor="let param of customTaskData$ | async" type="hidden" name="Parameters[{{param.name}}]" [value]="param.value" />

  <div class="form-actions">
    <div class="chat-button" #chatButtonWrapper>
      <button (focus)="toggleBorder(true)" (blur)="toggleBorder(false)" mat-raised-button class="form-action" [disabled]="!isBrowserSupported || form.invalid || formSubmitted"
        [ngStyle]="!form.invalid ? { 'background': settings.displaySetting.HeaderBackground, 'color': settings.displaySetting.HeaderFontColor } : ''"
        [style.font-family]="settings.displaySetting.Font">
        <strong class="uwf-send"></strong>

        <ng-container *ngIf="activeForm.headerFooters[0].sendButton; let sendButtonText">
          {{ sendButtonText }}
        </ng-container>
      </button>
    </div>
  </div>
  <div *ngIf="isBrowserSupported && reCaptchaEnabled && isActiveFormValid()" id="reCaptcha" class="reCaptcha-container">
    <!--Added label to resolve WCAG problem- "missing an associated label"-->
    <label for="g-recaptcha-response" hidden>reCaptcha response</label>
    <re-captcha #captchaRef="reCaptcha"
                [siteKey]="reCaptchaSiteKey"
                size="invisible"
                (resolved)="$event && reCaptchaResponseCallback($event)"
                badge="inline"
                [formControlName]='reCaptchaFormControlName'></re-captcha>
  </div>
</form>
